import Axios from 'axios'
import {staffUrls} from '../urls'
import router from '../../../router'

export default {
  get_all_staffs (context) {
    Axios.get(staffUrls.getAllStaffs).then(function (response) {
      context.commit('GET_ALL_STAFFS', response.data)
    })
  },
  get_staffs (context, publicId) {
    Axios.get(staffUrls.getStaffs + publicId).then(function (response) {
      context.commit('GET_STAFFS', response.data)
    })
  },
  get_deleted_staffs (context) {
    Axios.get(staffUrls.getDeletedStaff).then(function (response) {
      context.commit('GET_DELETED_STAFFS', response.data)
    })
  },
  get_staff (context, publicId) {
    Axios.get(staffUrls.getStaff + publicId).then(function (response) {
      context.commit('GET_STAFF', response.data)
    })
  },
  post_staff (context, data) {
    Axios.post(staffUrls.postStaff, data).then(function () {
      context.dispatch('get_all_staffs')
      router.push({
        name: 'AllStaff'
      })
    }).catch(function (error) {
      // console.log(error.data)
    })
  },
  update_staff (context, data) {
    Axios.post(staffUrls.editStaff + data.public_id, data).then(function () {
      context.dispatch('get_all_staffs')
      router.push({
        name: 'AllStaff'
      })
    }).catch(function (error) {
      context.commit('UPDATE_ERRORS', error.data)
      // console.log(error.data)
    })
  },
  delete_staff (context, data) {
    Axios.post(staffUrls.deleteStaff + data.public_id, data).then(function (response) {
      context.dispatch('get_all_staffs')
    })
  },
  restoreStaff (context, publicId) {
    Axios.get(staffUrls.restoreStaff + publicId).then(function (response) {
      alert(response.data.message)
      context.commit('GET_ALL_STAFFS', response.data)
      router.push({
        name: 'Module.Staffs'
      })
    })
  }
}
